"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAllergyStore = exports.CROSS_REACTIVITY_GROUPS = exports.MANIFESTATIONS = void 0;
var vuex_1 = require("vuex");
var vue_1 = require("vue");
var pinia_1 = require("pinia");
var apis_1 = require("@/constants/apis");
console.log("Initializing Pinia");
var axios_1 = require("axios");
// Common manifestations for allergies
exports.MANIFESTATIONS = [
    'Anaphylaxis',
    'Angioedema',
    'Bronchospasm',
    'Cardiac arrest',
    'Chest tightness',
    'Conjunctivitis',
    'Cough',
    'Diarrhea',
    'Dizziness',
    'Dyspnea',
    'Erythema',
    'Gastrointestinal upset',
    'Headache',
    'Hives',
    'Hypotension',
    'Itching',
    'Nausea',
    'Pruritus',
    'Rash',
    'Respiratory distress',
    'Rhinitis',
    'Shock',
    'Shortness of breath',
    'Sneezing',
    'Swelling',
    'Swollen lips',
    'Tachycardia',
    'Tearing',
    'Throat tightness',
    'Unconsciousness',
    'Urticaria',
    'Vomiting',
    'Wheezing'
];
// Common cross-reactivity groups
exports.CROSS_REACTIVITY_GROUPS = {
    'Penicillin': ['Amoxicillin', 'Ampicillin', 'Cephalosporins', 'Carbapenems'],
    'Sulfonamides': ['Sulfamethoxazole', 'Sulfasalazine', 'Thiazide diuretics'],
    'NSAIDs': ['Aspirin', 'Ibuprofen', 'Naproxen', 'Celecoxib'],
    'ACE Inhibitors': ['Lisinopril', 'Enalapril', 'Captopril', 'Ramipril'],
    'Shellfish': ['Shrimp', 'Crab', 'Lobster', 'Crayfish'],
    'Tree Nuts': ['Almonds', 'Walnuts', 'Cashews', 'Pistachios', 'Hazelnuts'],
    'Latex': ['Banana', 'Avocado', 'Kiwi', 'Chestnut'],
    'Mold': ['Penicillin', 'Cephalosporins'], // Some molds can produce penicillin-like compounds
    'Bees': ['Wasps', 'Hornets'], // Cross-reactivity between different stinging insects
    'Pollen': ['Apples', 'Carrots', 'Celery', 'Kiwi'], // Oral Allergy Syndrome (OAS) 
    'Milk': ['Goat Milk', 'Sheep Milk'], // Cross-reactivity in dairy allergies
    'Wheat': ['Barley', 'Rye'], // Gluten-related allergies
    'Fish': ['Cod', 'Haddock', 'Pollock', 'Tuna'], // Common fish allergies
    'Soy': ['Lentils', 'Peanuts'], // Some individuals with soy allergies may react to peanuts
};
//const CURR_API ="/keyon";
// Sample allergy data
var sampleAllergies = [
    {
        id: '1',
        name: 'Penicillin',
        type: 'drug',
        status: 'active',
        severity: 'severe',
        criticality: 'high',
        reactions: [
            { manifestation: 'Anaphylaxis', severity: 'life-threatening' },
            { manifestation: 'Hives', severity: 'moderate' },
            { manifestation: 'Swelling', severity: 'moderate' }
        ],
        onsetDate: '2019-03-15',
        recordedDate: '2019-03-20',
        resolvedDate: null,
        verificationStatus: 'confirmed',
        comments: '<p>Patient experienced <strong>severe anaphylactic reaction</strong> requiring epinephrine administration and hospitalization. Confirmed via skin prick test.</p>',
        recordedBy: 'Dr. Sarah Johnson',
        lastUpdatedBy: 'Dr. Sarah Johnson',
        lastUpdated: '2024-01-15',
        crossReactivity: ['Amoxicillin', 'Ampicillin', 'Cephalosporins']
    },
    {
        id: '2',
        name: 'Peanuts',
        type: 'food',
        status: 'active',
        severity: 'life-threatening',
        criticality: 'high',
        reactions: [
            { manifestation: 'Anaphylaxis', severity: 'life-threatening' },
            { manifestation: 'Throat tightness', severity: 'severe' },
            { manifestation: 'Respiratory distress', severity: 'severe' }
        ],
        onsetDate: '2015-06-01',
        recordedDate: '2015-06-10',
        resolvedDate: null,
        verificationStatus: 'confirmed',
        comments: '<p>Patient carries EpiPen at all times. <em>Avoid all peanut products and cross-contaminated foods.</em></p>',
        recordedBy: 'Dr. Michael Chen',
        lastUpdatedBy: 'Dr. Emily Davis',
        lastUpdated: '2024-02-20',
        crossReactivity: ['Tree Nuts']
    },
    {
        id: '3',
        name: 'Ibuprofen',
        type: 'drug',
        status: 'active',
        severity: 'moderate',
        criticality: 'low',
        reactions: [
            { manifestation: 'Rash', severity: 'mild' },
            { manifestation: 'Gastrointestinal upset', severity: 'moderate' }
        ],
        onsetDate: '2022-08-10',
        recordedDate: '2022-08-15',
        resolvedDate: null,
        verificationStatus: 'confirmed',
        comments: '<p>Developed rash and stomach upset after taking ibuprofen. Can use acetaminophen as alternative.</p>',
        recordedBy: 'Dr. Emily Davis',
        lastUpdatedBy: 'Dr. Emily Davis',
        lastUpdated: '2023-11-05',
        crossReactivity: ['Aspirin', 'Naproxen', 'NSAIDs']
    },
    {
        id: '4',
        name: 'Latex',
        type: 'environmental',
        status: 'active',
        severity: 'mild',
        criticality: 'low',
        reactions: [
            { manifestation: 'Contact dermatitis', severity: 'mild' },
            { manifestation: 'Itching', severity: 'mild' }
        ],
        onsetDate: '2020-01-20',
        recordedDate: '2020-02-01',
        resolvedDate: null,
        verificationStatus: 'unconfirmed',
        comments: '<p>Reports skin irritation when in contact with latex gloves. Use non-latex alternatives.</p>',
        recordedBy: 'Nurse Patricia Brown',
        lastUpdatedBy: 'Nurse Patricia Brown',
        lastUpdated: '2023-06-12',
        crossReactivity: ['Banana', 'Avocado', 'Kiwi']
    },
    {
        id: '5',
        name: 'Codeine',
        type: 'drug',
        status: 'resolved',
        severity: 'moderate',
        criticality: 'low',
        reactions: [
            { manifestation: 'Nausea', severity: 'moderate' },
            { manifestation: 'Vomiting', severity: 'moderate' }
        ],
        onsetDate: '2018-05-12',
        recordedDate: '2018-05-15',
        resolvedDate: '2023-03-01',
        verificationStatus: 'refuted',
        comments: '<p>Initially reported as allergy but later determined to be an adverse effect, not a true allergy. Tolerated small dose in controlled setting.</p>',
        recordedBy: 'Dr. Robert Wilson',
        lastUpdatedBy: 'Dr. Sarah Johnson',
        lastUpdated: '2023-03-01',
        crossReactivity: []
    }
];
exports.useAllergyStore = (0, pinia_1.defineStore)('allergies', function () {
    console.log("Allergy Store Initialized");
    //const allergies = ref<Allergy[]>([...sampleAllergies])
    // Vuex store access MUST happen at runtime (inside this function), not at module import
    var vuex = (0, vuex_1.useStore)();
    var allData = (0, vue_1.computed)(function () {
        // guard in case vuex or getters are missing during early startup
        return vuex && vuex.getters ? vuex.getters['login/getAllData'] : { manager: {}, patient: {} };
    });
    var allergies = (0, vue_1.ref)([]);
    var searchQuery = (0, vue_1.ref)('');
    var statusFilter = (0, vue_1.ref)('all');
    var severityFilter = (0, vue_1.ref)('all');
    //Fetch Allergies on Store init
    var filteredAllergies = (0, vue_1.computed)(function () {
        return allergies.value.filter(function (allergy) {
            var matchesSearch = allergy.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
                allergy.type.toLowerCase().includes(searchQuery.value.toLowerCase());
            var matchesStatus = statusFilter.value === 'all' || allergy.status === statusFilter.value;
            var matchesSeverity = severityFilter.value === 'all' || allergy.severity === severityFilter.value;
            return matchesSearch && matchesStatus && matchesSeverity;
        });
    });
    var activeAllergies = (0, vue_1.computed)(function () { return allergies.value.filter(function (a) { return a.status === 'active'; }); });
    var highCriticalityCount = (0, vue_1.computed)(function () { return allergies.value.filter(function (a) { return a.criticality === 'high' && a.status === 'active'; }).length; });
    //4-8-26 KW adding new function 
    function addAllergy(allergy) {
        var newAllergy = __assign(__assign({}, allergy), { id: Date.now().toString(), recordedDate: new Date().toISOString().split('T')[0], lastUpdated: new Date().toISOString().split('T')[0] });
        allergies.value.unshift(newAllergy);
        return newAllergy;
    }
    function updateAllergy(id, updates) {
        var index = allergies.value.findIndex(function (a) { return a.id === id; });
        if (index !== -1) {
            allergies.value[index] = __assign(__assign(__assign({}, allergies.value[index]), updates), { lastUpdated: new Date().toISOString().split('T')[0] });
            return allergies.value[index];
        }
        return null;
    }
    function getAllergyById(id) {
        return allergies.value.find(function (a) { return a.id === id; });
    }
    /*function getCrossReactivityWarnings(allergyName: string): string[] {
      const warnings: string[] = []
      for (const [group, members] of Object.entries(CROSS_REACTIVITY_GROUPS)) {
        if (members.some(m => allergyName.toLowerCase().includes(m.toLowerCase())) ||
            allergyName.toLowerCase().includes(group.toLowerCase())) {
          warnings.push(...members.filter(m => !allergyName.toLowerCase().includes(m.toLowerCase())))
        }
      }
      return [...new Set(warnings)]
    }*/
    function getCrossReactivityWarnings(allergyName) {
        if (!allergyName)
            return [];
        var name = allergyName.trim().toLowerCase();
        var warnings = [];
        for (var _i = 0, _a = Object.entries(exports.CROSS_REACTIVITY_GROUPS); _i < _a.length; _i++) {
            var _b = _a[_i], group = _b[0], members = _b[1];
            var groupLower = group.toLowerCase();
            if (members.some(function (m) { return name.includes(m.toLowerCase()); }) || name.includes(groupLower)) {
                warnings.push.apply(warnings, members.filter(function (m) { return !name.toLocaleLowerCase().includes(m.toLowerCase()); }));
            }
        }
        console.log("WARNINGS GETGROSS");
        console.log(warnings);
        return Array.from(new Set(warnings));
    }
    function getbackendAllergies() {
        return __awaiter(this, void 0, void 0, function () {
            var managerId, patientId, provsubaccount, content, response, error_1;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        console.log("Inside");
                        managerId = (_b = (_a = allData.value) === null || _a === void 0 ? void 0 : _a.patient) === null || _b === void 0 ? void 0 : _b.externId2;
                        patientId = (_d = (_c = allData.value) === null || _c === void 0 ? void 0 : _c.patient) === null || _d === void 0 ? void 0 : _d.externId;
                        provsubaccount = (_f = (_e = allData.value) === null || _e === void 0 ? void 0 : _e.manager) === null || _f === void 0 ? void 0 : _f.externid;
                        content = {
                            MedicationAdmin: {
                                API_Meth: "getPatientAllergies",
                                accountnumber: managerId, //"904575107",
                                patientid: patientId, // "709081242",
                                provsubaccount: provsubaccount
                            }
                        };
                        // Clear previous allergies
                        allergies.value = [];
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 3, , 4]);
                        console.log(apis_1.CURR_API);
                        return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content)];
                    case 2:
                        response = _h.sent();
                        // Check for data in response
                        console.log(response.data);
                        if (response.data && Array.isArray(response.data.message)) {
                            console.log("Logging Results of Axios Call");
                            console.log(response.data.message);
                            // Map and set the allergies
                            allergies.value = response.data.message.map(function (item) { return ({
                                id: item.id,
                                name: item.name,
                                type: item.category,
                                status: item.status,
                                severity: item.severity,
                                criticality: item.criticality,
                                reactions: JSON.parse(item.reactions).map(function (reaction) { return ({
                                    manifestation: reaction.manifestation, // ensure key is correct
                                    severity: reaction.severity
                                }); }),
                                onsetDate: item.date_diagnosed,
                                recordedDate: item.created_at,
                                resolvedDate: item.resolvedDate,
                                verificationStatus: item.verification_status,
                                comments: item.description,
                                recordedBy: item.provider_assign_name,
                                lastUpdatedBy: item.lastUpdatedBy,
                                lastUpdated: item.updated_at,
                                crossReactivity: Array.isArray(item.crossReactivity) ? item.crossReactivity : [] // Ensure it's always an array
                            }); });
                        }
                        else {
                            console.warn("No valid data received");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _h.sent();
                        if (axios_1.default.isAxiosError(error_1)) {
                            alert("Code:340 - System issue. Please contact system support");
                            console.error('Error posting data:', ((_g = error_1.response) === null || _g === void 0 ? void 0 : _g.data) || error_1.message);
                        }
                        else {
                            alert("Oops, we hit an unexpected snag, please contact your system administrator if this error persists.");
                            console.error('Unexpected error:', error_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return {
        allergies: allergies,
        searchQuery: searchQuery,
        statusFilter: statusFilter,
        severityFilter: severityFilter,
        filteredAllergies: filteredAllergies,
        activeAllergies: activeAllergies,
        highCriticalityCount: highCriticalityCount,
        addAllergy: addAllergy,
        updateAllergy: updateAllergy,
        getAllergyById: getAllergyById,
        getCrossReactivityWarnings: getCrossReactivityWarnings,
        getbackendAllergies: getbackendAllergies
    };
});
